import { useDataProvider, ReferenceInput, required, SelectInput, NumberInput, AutocompleteInput } from "react-admin";

import { Box, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { administrationRequests } from "api/administrationApi";
import { InstructionLanguage } from "utils/constants";
import CheckStudentDialog from "./CheckStudentDialog";

const Education = ({
  specialityId,
  setSpecialityId,
  isDisable,
  userData,
  isKSK = false,
  isOther = false,
  isPms = false,
  isIndividual = false,
  isForeigner = false,
  setLanguageId,
}) => {
  //sections components
  const [canPickForeignLanguage, setCanPickForeignLanguage] = useState(null);
  const dataProvider = useDataProvider();

  const { setValue } = useFormContext();
  const instructionLanguageId = useWatch({ name: "instructionLanguageId" });

  useEffect(() => {
    if (specialityId && instructionLanguageId == null) {
      setValue("instructionLanguageId", userData?.instructionLanguageId ?? InstructionLanguage.Bulgarian, {
        shouldValidate: true,
      });
    }
  }, [specialityId, instructionLanguageId, userData, setValue]);

  // Синхронизира languageId (ползван за зареждане на учебния план) със стойността на формата.
  useEffect(() => {
    setLanguageId(instructionLanguageId ?? null);
  }, [instructionLanguageId, setLanguageId]);

  useEffect(() => {
    if (!specialityId) return;
    const fetchSpecialityFlags = async () => {
      try {
        const { data } = await dataProvider.customRequest(administrationRequests.getSpecialityFlags(specialityId));
        setCanPickForeignLanguage(data?.canPickForeignLanguage);
      } catch (err) {
        console.error("Неуспешно зареждане на флаговете за специалността", err);
        setCanPickForeignLanguage(null);
      }
    };
    fetchSpecialityFlags();
  }, [specialityId, dataProvider]);

  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
        md={4}
      >
        <ReferenceInput
          source="specialityId"
          reference={administrationRequests.getSpecialitiesSelect()}
        >
          <SelectInput
            disabled={isKSK}
            onChange={e => {
              if (e) {
                setSpecialityId(e.target.value);
              } else {
                setSpecialityId(null);
              }
            }}
            defaultValue={userData?.specialityId || null}
            label="Специалност"
            validate={required("Задължително")}
            readOnly={isDisable}
          />
        </ReferenceInput>
        {isForeigner && (
          <Box sx={{ mb: 2 }}>
            <CheckStudentDialog disabled={isDisable} />
          </Box>
        )}
      </Grid>

      {specialityId && canPickForeignLanguage ? (
        <Grid
          item
          xs={12}
          md={4}
        >
          <ReferenceInput
            reference={administrationRequests.getForeignLanguagesSelect()}
            source={"foreignLanguageId"}
          >
            <SelectInput
              label="Избор на чужд език"
              optionText={"name"}
              optionValue="id"
            />
          </ReferenceInput>
        </Grid>
      ) : null}
      {specialityId && (
        <Grid
          item
          xs={12}
          md={4}
        >
          <ReferenceInput
            source="instructionLanguageId"
            reference={administrationRequests.getInstructionLanguagesBySpecialityId(specialityId)}
          >
            <AutocompleteInput
              optionText="nameBg"
              optionValue="id"
              label="Език на обучение"
              validate={isForeigner ? null : required("Задължително")}
              defaultValue={userData?.instructionLanguageId || ""}
              readOnly={isDisable || userData?.instructionLanguageId}
              fullWidth
            />
          </ReferenceInput>
        </Grid>
      )}
      {specialityId && (
        <Grid
          item
          xs={12}
          md={4}
        >
          <ReferenceInput
            source="studyTypeId"
            reference={administrationRequests.getStudyTypesBySpecialityId(specialityId)}
          >
            <SelectInput
              defaultValue={userData?.studyTypeId || ""}
              validate={isForeigner ? null : required("Задължително")}
              label="Тип образование"
              optionText="nameBg"
              readOnly={isDisable || isKSK}
            />
          </ReferenceInput>
        </Grid>
      )}

      {!isOther && !isPms && (
        <Grid
          item
          md={4}
        >
          <NumberInput
            label="Бал"
            source="score"
            defaultValue={userData?.score}
            validate={!isIndividual && !isForeigner ? required("Задължително") : null}
            readOnly={isDisable || isKSK}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default Education;
